<script>
export default {
    name: 'IlluProgressionEtapes',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-progression-etapes"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M50.506 9.5l4.392 9.053-4.04-.048-.009.092c-1.865 18.602-14.177 29.256-36.791 31.9a.5.5 0 01-.116-.994c22.177-2.592 34.1-12.907 35.913-31.01l-3.956-.047L50.506 9.5z"
                :fill="secondaryColor"
                class="secondary-color"
                fill-rule="nonzero"
            />
            <path
                d="M14 46a4 4 0 110 8 4 4 0 010-8zm20-6a4 4 0 110 8 4 4 0 010-8zm13-13a4 4 0 110 8 4 4 0 010-8z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
